/* Used for push notifications, cookies and popups. */
import React, { Component } from 'react';
import { hot } from 'react-hot-loader';
import Transition from 'react-transition-group/Transition';
import Button from '../Elements/Button/Button';
import Newsletter from '../Footer/Newsletter';
import { addEvent, removeEvent, purifier } from '../../utils/dom';
import { translate } from '../../utils/locale';
import { urlify } from '../../utils/string';
import s from './Notification.scss';

class Notification extends Component {
	campaignCycle = false;

	constructor(props) {
		super(props);

		this.notificationInner = React.createRef();
		this.notificationBanner = React.createRef();

		this.state = {
			notificationIndex: 0,
			messageScrolling: false,
			delay: {},
		};
	}

	componentDidMount() {
		const { setup, type, content = [] } = this.props;
		const started = window.performance.now();
		const notifications = content.filter((n) => n?.text && ((n.countryRestrict && n.countryRestrict.indexOf(setup.country) !== -1) || !n.countryRestrict));
		let isMessageScrolling = false;

		addEvent(document.querySelector('body'), 'click.notificationClose', (e) => {
			if (this.notificationInner.current && !this.notificationInner.current.contains(e.target) && this.props.type === 'popup') {
				e.preventDefault();
				e.stopPropagation();
				this.removeNotificationHandler(e);
			}
		});

		notifications.forEach((item) => {
			const notificationName = urlify(item.name);
			if (item.delay) {
				this.setState((prevState) => ({
					delay: {
						...prevState.delay,
						[notificationName]: false,
					},
				}));
				setTimeout(() => {
					this.setState((prevState) => ({
						delay: {
							...prevState.delay,
							[notificationName]: true,
						},
					}));
				}, parseInt(item.delay, 10) * 1e3);
			}
		});

		const toggleMessagescrolling = () => {
			if (window.innerWidth < 600 && !isMessageScrolling) {
				isMessageScrolling = true;
				this.setState({ messageScrolling: 1 });
			} else if (window.innerWidth > 600 && isMessageScrolling) {
				isMessageScrolling = false;
				this.setState({ messageScrolling: false });
			}
		};

		addEvent(window, 'resize.windowResize', () => {
			toggleMessagescrolling();
		});

		const initiateSiteListeners = () => {
			if (!notifications && started + 2000 < window.performance.now()) {
				setTimeout(initiateSiteListeners, 200);
			}

			if (this.notificationBanner.current) {
				toggleMessagescrolling();
			}

			if (notifications && notifications.length > 1 && type === 'campaign') {
				this.campaignCycle = setInterval(() => {
					this.setState((prevState) => ({ notificationIndex: prevState.notificationIndex + 1 }));
				}, 4000);
			}
		};

		initiateSiteListeners();
	}

	componentWillUnmount() {
		clearInterval(this.campaignCycle);
		removeEvent(window, 'resize.windowResize');
		removeEvent(document.querySelector('body'), 'click.notificationClose');
	}

	removeNotificationHandler = (e) => {
		if (e) e.preventDefault();

		const $notificationElement = this.notificationInner.current;
		const cookieName = $notificationElement.dataset.name;
		const cookieDuration = $notificationElement.dataset.duration;

		let date = new Date();
		date = date.setTime(date.getTime() + (cookieDuration * 1000));

		const expires = `expires=${new Date(date).toGMTString()}; `;

		document.cookie = `${cookieName}=1; ${expires}path=/`;

		// Notify Redux that we have removed the item.
		this.props.notificationRemoved();
		this.props.removeNotification(this.props.type, cookieName);
	}

	render() {
		const { type, content, setup } = this.props;
		const { notificationIndex, delay, messageScrolling } = this.state;

		if (!content) return null;
		const notifications = content.filter((n) => n?.text && ((n.countryRestrict && n.countryRestrict.indexOf(setup.country) !== -1) || !n.countryRestrict));

		const newsletterSubmitHandler = () => {
			setTimeout(() => {
				this.removeNotificationHandler();
			}, 500);
		};

		return (
			<div className={[s.notification, s[`notification__${type}`]].join(' ')}>
				{
					notifications.map((item, i) => {
						const notificationName = urlify(item.name);
						const notificationAttributes = {};
						const notificationInnerClasses = [s.notification_inner, (item.removeText ? [s.notification_inner__closeText] : null)];

						if (item.backgroundColor) notificationInnerClasses.push(s[`notification_inner__${item.backgroundColor.toLowerCase()}`]);
						if (item.stickToBottom) notificationInnerClasses.push(s.notification_inner__stickToBottom);
						if (notificationIndex % notifications.length === i) notificationInnerClasses.push(s.notification_inner__selected);

						// Check for cookies which are already set.
						if ((item.removable || type === 'popup') && item.cookieDuration) {
							let cookieIsSet = false;

							const cookies = typeof document !== 'undefined' ? document.cookie : setup.cookies;
							if (typeof cookies === 'object') {
								if (cookies[notificationName]) cookieIsSet = true;
							} else if (cookies) {
								cookies.split(';').forEach((cookie) => {
									// Cookie is set don't display notification.
									if (cookie.indexOf(notificationName) !== -1) cookieIsSet = true;
								});
							}

							// Item shown already.
							if (cookieIsSet && item.removed !== true) return null;
							// Item delayed don't show yet.
							if (item.delay && !delay[notificationName]) return null;

							notificationAttributes['data-name'] = notificationName;
							notificationAttributes['data-duration'] = item.cookieDuration;
						}

						let innerTextContent = translate(setup, item?.text).replace('%country%', setup.countries[setup.country].name);

						if (type === 'campaign' && messageScrolling) {
							innerTextContent = `${innerTextContent}${innerTextContent}${innerTextContent}${innerTextContent}${innerTextContent}`;
						}

						innerTextContent = `<div>${innerTextContent}</div>`;

						return (
							<Transition in={item.removed !== true} timeout={300} key={notificationName} unmountOnExit>
								{(state) => (
									<>
										{ type === 'popup' && <button className={[s.notification_screen, s[`notification_screen__${state}`]].join(' ')} type="button" onClick={this.removeNotificationHandler} aria-label="Close" /> }
										<div ref={this.notificationInner} className={[...notificationInnerClasses, s[`notification_inner__${state}`]].join(' ')} {...notificationAttributes}>
											<div className={s.notification_inner_wrapper}>
												<div ref={this.notificationBanner} className={s.notification_inner_text} dangerouslySetInnerHTML={{ __html: purifier(innerTextContent) }} />
												{
													item.includeNewsletter ? <div className={s.notification_inner_newsletter}><Newsletter callback={newsletterSubmitHandler} popup /></div> : null
												}
												{
													(item.removable || type === 'popup') && item.cookieDuration && (
														<Button type="a" location="#close" clickEventHandler={this.removeNotificationHandler} variantClasses={item.removeText ? ['button__outline'] : ['button__invisible']}>
															{
																item.removeText && translate(setup, item.removeText)
															}
															{
																!item.removeText && type === 'popup' && (
																	<span className={s.notification_inner_close}>
																		<svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
																			<line x1="0.108019" y1="0.894605" x2="10.5769" y2="11.3634" strokeWidth="0.5" />
																			<line x1="10.5748" y1="1.10607" x2="0.105981" y2="11.5749" strokeWidth="0.5" />
																		</svg>
																	</span>
																)
															}
															{
																!item.removeText && type !== 'popup' && (
																	<span className={s.notification_inner_close}>
																		<svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
																			<line x1="0.108019" y1="0.894605" x2="10.5769" y2="11.3634" strokeWidth="0.5" />
																			<line x1="10.5748" y1="1.10607" x2="0.105981" y2="11.5749" strokeWidth="0.5" />
																		</svg>
																		<svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
																			<line x1="0.176777" y1="0.823223" x2="14.3189" y2="14.9654" strokeWidth="0.5" />
																			<line x1="14.3174" y1="1.17678" x2="0.175266" y2="15.3189" strokeWidth="0.5" />
																		</svg>
																	</span>
																)
															}
														</Button>
													)
												}
											</div>
										</div>
									</>
								)}
							</Transition>
						);
					})
				}
			</div>
		);
	}
}

export default hot(module)(Notification);
